import { PaymentTerms } from '@lombok/shared';
import type { PaymentTerms as PaymentTermsType } from '@lombok/shared';
import type { SelectOption } from '@/components/form';

/**
 * Shared Spanish display labels and form options for the admin slice. Stored
 * values stay snake_case (from @lombok/shared enums); only the labels shown to
 * users are Spanish. Centralized so list, create, and detail screens agree.
 */
export const TERMS_LABELS_ES: Record<PaymentTermsType, string> = {
  [PaymentTerms.UPFRONT]: 'Contado',
  [PaymentTerms.NET_7]: 'Net 7',
  [PaymentTerms.NET_15]: 'Net 15',
  [PaymentTerms.NET_30]: 'Net 30',
  [PaymentTerms.CUSTOM]: 'Personalizado',
};

export const PAYMENT_TERMS_OPTIONS: readonly SelectOption[] = Object.values(PaymentTerms).map(
  (value) => ({ value, label: TERMS_LABELS_ES[value] }),
);
